module.exports = __webpack_public_path__ + "static/media/debby_chang.1cdd40db.jpg";